import { Injectable } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';

import { TranslateService } from '@ngx-translate/core';
import { IonicSafeString } from '@ionic/angular';
import { Timestamp } from '@angular/fire/firestore';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToolsService {

  constructor(private t:TranslateService, private alert: AlertController, private toast: ToastController) { }

  public async presentToast(text: string) {
    let text2 = typeof(text)=="string" ? await this.t.get(text).toPromise(): text;
    let toast = await this.toast.create({
      animated: true,
      duration: 2000,
      header: text2,
      position: 'bottom',
      translucent: true
    });
    toast.present();
  }

  //version for arrays of text with translate
  public async presentToast2(text: string[]) {
    let t = "";
    for (let i=0; i<text.length; i++) {
      let element = text[i];
      let t2 = typeof(element)=="string" ? await this.t.get(element).toPromise(): element;
      t += t2;
    };
    let toast = await this.toast.create({
      animated: true,
      duration: 2000,
      header: t,
      position: 'bottom',
      translucent: true
    });
    toast.present();
  }

  public async presentAlert(header:string, msg: string) {
    let h2 = typeof(header)=="string" ? await this.t.get(header).toPromise(): header;
    let msg2 = typeof(msg)=="string" ? await this.t.get(msg).toPromise(): msg;

    const a = await this.alert.create({
      header: h2,
      message: new IonicSafeString(msg2),
      buttons: ['OK']
    });
    await a.present();
  }



  // parameters are string arrays, each strings translated and concatenated
  public async presentAlert2(header:string[], msg: string[]) {
    let h = "";
    for (let i=0; i<header.length; i++) {
      let element = header[i];
      let h2 = typeof(element)=="string" ? await this.t.get(element).toPromise(): element;
      h += h2;
    };
    let m = "";
    for (let i=0; i<msg.length; i++) {
      let element = msg[i];
      let m2 = typeof(element)=="string" ? await this.t.get(element).toPromise(): element;
      m += m2;
    };
    const a = await this.alert.create({
      header: h,
      message: m,
      buttons: ['OK']
    });
    await a.present();
  }

  //call this function like this:
  /*this.myservice.presentConfirm('caption','text','Cancel','OK').then(res => {
      if (res === 'ok') {
        // codes
      }
    });*/
  async presentConfirm(header: any,msg: any,cancelText: any,okText: any): Promise<any> {
    return new Promise(async (resolve) => {
      const alert = await this.alert.create({
        header: await this.t.get(header).toPromise(),
        message: await this.t.get(msg).toPromise(),
        buttons: [
          {
            text: await this.t.get(cancelText).toPromise(),
            role: 'cancel',
            cssClass: 'secondary',
            handler: (cancel) => {
              resolve('cancel');
            }
          }, {
            text: await this.t.get(okText).toPromise(),
            handler: (ok) => {
              resolve('ok');
            }
          }
        ]
      });
      alert.present();
    });
  }

  public now(): string {
    return (new Date()).toISOString();
  }

  //calculates difference in DAYS of 2 ISO-Dates disregarding the time
  public dayDiff(date1: string, date2: string): number {
    let d1= new Date(date1);
    let d1n = new Date(d1.getFullYear(),d1.getMonth(),d1.getDate())
    let d2= new Date(date2);
    let d2n = new Date(d2.getFullYear(),d2.getMonth(),d2.getDate())
    return (d2n.getTime() - d1n.getTime())/ (1000 * 3600 * 24);
  }

  public printDate(isoDate: string, withYear: boolean = true): string {
    let d = new Date(isoDate);
    if (withYear)
      return d.getDate()+"."+(d.getMonth()+1)+"."+d.getFullYear();
    else
      return d.getDate()+"."+(d.getMonth()+1);
  }

  public printTime(isoDate: string): string {
    let d = new Date(isoDate); 
    return d.toLocaleTimeString(); //d.getHours().+"."+(d.getMinutes());
  }

  public printDateOrTime(isoDate: string) {
    let now = new Date();
    let d = new Date(isoDate);
    if (this.printDate(now.toISOString())==this.printDate(isoDate))
      if (this.t.currentLang=='de')
        return "heute: " + this.printTime(isoDate);
      else 
        return "today: " + this.printTime(isoDate);
    else
      return this.printDate(isoDate,true);
  }

  public printTimestamp(ts: Timestamp) {
    if (ts) {
      const dt = ts.toDate();
      const isoD = dt.toISOString();
      return this.printDateOrTime(isoD);
    }
  }

  public TimeStampToISODate(ts: Timestamp): string {
    if (ts) {
      //console.log("TimeStampToISODate: ",ts);
      //console.log("Type: ", typeof(ts));
      let dt: Date;
      try {
        dt = ts.toDate();
        //console.log("TimeStampToISODate: ",dt); 
      } catch (error) {
        console.log(error);
        console.log("TimeStampToISODate: ",dt);
      }
      if (dt)
        return dt.toISOString().slice(0,10);
      else
        return "";
    } else {
      return "";
    }
  }

  public getTimeStampOfWeekStart(): Timestamp {
    let nowTS: Timestamp = Timestamp.now();
    let nowDT: Date = nowTS.toDate();
    let utcYear = nowDT.getUTCFullYear();
    let utcMonth = nowDT.getUTCMonth();
    let utcDate = nowDT.getUTCDate();
    let utcHours = nowDT.getUTCHours();
    let utcMinutes = nowDT.getUTCMinutes();
    let utcSeconds = nowDT.getUTCSeconds();
    let utcMiliSeconds = nowDT.getUTCMilliseconds();
    let utcDay = nowDT.getUTCDay();

    let newSecs = nowTS.seconds-(utcDay*24*60*60+utcHours*60*60+utcMinutes*60+utcSeconds);
    //let newSecs = nowTS.seconds-60*60*24;
    let newTS = Timestamp.fromMillis(newSecs*1000);
    let newDT = newTS.toDate();

    console.log(nowTS);
    console.log(nowDT);
    console.log(utcDate + "." + utcMonth + "." + utcYear + "  " + utcHours + ":" + utcMinutes + ":" + utcSeconds);
    console.log(utcDay);
    console.log(newSecs);
    console.log(newTS);
    console.log(newDT);
    return null;
  }

}
